// extracted by mini-css-extract-plugin
export default {"files":"File_files__BiIIF","check":"File_check__c74vI","deleteBtn":"File_deleteBtn__Hh2fd","fileBtn":"File_fileBtn__ewouQ"};